import { render } from "./EditUserProfile.vue?vue&type=template&id=0dedca3d&scoped=true"
import script from "./EditUserProfile.vue?vue&type=script&lang=js"
export * from "./EditUserProfile.vue?vue&type=script&lang=js"

import "./EditUserProfile.vue?vue&type=style&index=0&id=0dedca3d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dedca3d"]])

export default __exports__